<script lang="ts" setup>
import {computed, ref} from "vue";
import {captureException, captureMessage} from "@sentry/browser";
import {useQuizStore} from '@/stores/quizStore';
import QuizButton from '@/components/Quiz/QuizButton.vue'
import VehicleAcquirementList from "@/components/Quiz/VehicleAcquirementList.vue";
import QuizSecureTag from "@/components/Quiz/QuizSecureTag.vue";
import {appendData} from "@/services/quizService.ts";
import type {IVehicle} from "@/types/vehicle.ts";

const {
  selectedVehicles,
  goToNextStep,
  getStoredData,
  setIsFetching,
  setVehicles,
  showAlert,
} = useQuizStore()
const vehiclesWithSelectedAcquirementDate = ref([...selectedVehicles]);

const isValid = computed(() => vehiclesWithSelectedAcquirementDate.value.every(v => !!v.selected_date))

function handleSubmit() {
  if (!isValid.value) return

  const {contact, ...payload} = getStoredData()
  payload.vehicles = payload.vehicles
    .map((vehicle: IVehicle) => {
      const item = vehiclesWithSelectedAcquirementDate.value.find(v => v.vin === vehicle.vin)
      return item ? item : vehicle
    })

  setIsFetching(true)
  appendData(payload)
    .then(() => {
      setVehicles(payload.vehicles)
      goToNextStep()
    })
    .catch(async (err) => {
      const response = await err.response?.json()
      if (response?.error) {
        showAlert(response.error)
      } else {
        captureMessage("Error on appendData: VehicleAcquisitionDates.vue");
        captureException(err);
      }
    })
    .finally(() => {
      setIsFetching(false)
    })
}
</script>

<template>
  <form @submit.prevent="handleSubmit">
    <VehicleAcquirementList v-model="vehiclesWithSelectedAcquirementDate" class="mb-6"/>

    <QuizButton label="Continue" id="vehicle-acquisition-date-button" :disabled="!isValid"/>
  </form>

  <QuizSecureTag class="mt-6"/>
</template>
